import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { PermissionApprovalComponent, PermissionApprovalListComponent, PermissionRequestComponent, PermissionUserViewComponent, SpecialpermissionAddEditComponent, SpecialpermissionListComponent } from '@user/components/special-permission';

const routes: Routes = [
  { path: 'list', component: SpecialpermissionListComponent, canActivate: [AuthGuard], data: { title: 'Leave Permission Request List' } },
  { path: 'list/add-request', component: PermissionRequestComponent, canActivate: [AuthGuard], data: { title: 'Create - Edit request' } },
  { path: 'approval-list', component: PermissionApprovalListComponent, canActivate: [AuthGuard], data: { title: 'Leave Permission Approval List' } },
  { path: 'list/request-view', component: PermissionUserViewComponent, canActivate: [AuthGuard], data: { title: 'Leave Requester View Info' } },
  { path: 'approval-list/approval', component: PermissionApprovalComponent, canActivate: [AuthGuard], data: { title: 'Leave Permission Approval' } }
];
@NgModule({
  declarations: [SpecialpermissionAddEditComponent, SpecialpermissionListComponent,
    PermissionRequestComponent, PermissionApprovalListComponent, PermissionUserViewComponent,
    PermissionApprovalComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MaterialModule,
    SharedModule,
  ],
  entryComponents: [SpecialpermissionAddEditComponent]
})
export class SpecialPermissionModule { }
